// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  padding: 0 24px !important;
}
.modal-content .title-centered-v1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0 16px;
}
.modal-content .title-centered-v1 h1 {
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 0;
}
.modal-content .title-centered-v1 .modal-subtitulo {
  font-family: "Barlow", sans-serif;
  font-size: 14px;
  color: #555;
  margin: 8px 0 0;
  text-align: center;
}

.interacoes-table {
  width: 100%;
}
.interacoes-table .mat-column-dataHoraUsuario {
  width: 18%;
}
.interacoes-table .mat-column-statusOrigemDestino {
  width: 25%;
}
.interacoes-table .mat-column-comentario {
  width: 30%;
  white-space: normal;
}
.interacoes-table .mat-column-parecer {
  width: 16%;
}
.interacoes-table .mat-column-anexos {
  width: 11%;
  text-align: center;
}

:host ::ng-deep .interacoes-table .mat-mdc-header-row {
  background: #F4F4F4;
  height: 50px;
}

:host ::ng-deep .interacoes-table .mat-mdc-header-cell {
  font-family: "Barlow", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #000;
  border-bottom: 1px solid #E0E0E0;
  padding: 0 12px;
}

:host ::ng-deep .interacoes-table .mat-mdc-row {
  border-bottom: 1px solid #F0F0F0;
}
:host ::ng-deep .interacoes-table .mat-mdc-row:last-child {
  border-bottom: none;
}

:host ::ng-deep .interacoes-table .mat-mdc-cell {
  font-family: "Barlow", sans-serif;
  font-size: 14px;
  color: #333;
  padding: 12px;
  border-bottom: none;
}

.usuario-nome {
  color: #777;
  font-size: 12px;
  display: block;
  margin-top: 2px;
}

.sem-dados {
  text-align: center;
  padding: 24px;
  color: #999;
  font-size: 14px;
}

.dialog-actions {
  padding: 16px 24px;
  margin: 0;
  border-top: 1px solid #e0e0e0;
}
.dialog-actions .buttons {
  width: 100%;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/modals/modal-interacoes-analise/modal-interacoes-analise.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AACJ;AACI;EACE,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AACN;AAEI;EACE,iCAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAAN;;AAKA;EACE,WAAA;AAFF;AAIE;EAAkC,UAAA;AADpC;AAEE;EAAkC,UAAA;AACpC;AAAE;EAAkC,UAAA;EAAY,mBAAA;AAIhD;AAHE;EAAkC,UAAA;AAMpC;AALE;EAAkC,UAAA;EAAY,kBAAA;AAShD;;AANA;EACE,mBAAA;EACA,YAAA;AASF;;AANA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;AASF;;AANA;EACE,gCAAA;AASF;AAPE;EACE,mBAAA;AASJ;;AALA;EACE,iCAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAQF;;AALA;EACE,WAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAQF;;AALA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAQF;;AALA;EACE,kBAAA;EACA,SAAA;EACA,6BAAA;AAQF;AANE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAQJ","sourcesContent":[".modal-content {\n  padding: 0 24px !important;\n\n  .title-centered-v1 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 24px 0 16px;\n\n    h1 {\n      font-family: 'Montserrat', sans-serif;\n      font-size: 24px;\n      font-weight: 600;\n      color: #000;\n      margin: 0;\n    }\n\n    .modal-subtitulo {\n      font-family: 'Barlow', sans-serif;\n      font-size: 14px;\n      color: #555;\n      margin: 8px 0 0;\n      text-align: center;\n    }\n  }\n}\n\n.interacoes-table {\n  width: 100%;\n\n  .mat-column-dataHoraUsuario     { width: 18%; }\n  .mat-column-statusOrigemDestino { width: 25%; }\n  .mat-column-comentario          { width: 30%; white-space: normal; }\n  .mat-column-parecer             { width: 16%; }\n  .mat-column-anexos              { width: 11%; text-align: center; }\n}\n\n:host ::ng-deep .interacoes-table .mat-mdc-header-row {\n  background: #F4F4F4;\n  height: 50px;\n}\n\n:host ::ng-deep .interacoes-table .mat-mdc-header-cell {\n  font-family: 'Barlow', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #000;\n  border-bottom: 1px solid #E0E0E0;\n  padding: 0 12px;\n}\n\n:host ::ng-deep .interacoes-table .mat-mdc-row {\n  border-bottom: 1px solid #F0F0F0;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n:host ::ng-deep .interacoes-table .mat-mdc-cell {\n  font-family: 'Barlow', sans-serif;\n  font-size: 14px;\n  color: #333;\n  padding: 12px;\n  border-bottom: none;\n}\n\n.usuario-nome {\n  color: #777;\n  font-size: 12px;\n  display: block;\n  margin-top: 2px;\n}\n\n.sem-dados {\n  text-align: center;\n  padding: 24px;\n  color: #999;\n  font-size: 14px;\n}\n\n.dialog-actions {\n  padding: 16px 24px;\n  margin: 0;\n  border-top: 1px solid #e0e0e0;\n\n  .buttons {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
